<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/sellerDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Orders</li>
    </ol>
  </nav>
  <div class="row" *ngIf="totalRecords === 0">
    <div class="col">
      <div class="inner-box no-listbox">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-right">
            <img src="assets/images/Emptyscreen - Orders.png">
          </div>
          <div class="col-md-6">
            <h1 class="f-46 text-orange">Sync Your Orders!!</h1>
            <a>
              <button class="btn btn-orange-prime mt-4" (click)="syncOrders()">Sync now</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="totalRecords != 0">
    <div class="invalid-feedback d-block shift-invalid-text w-75" [hidden]="!errorMessage">{{errorMessage}}</div>
    <div class="row align-items-center">
      <div class="col-md-8">
        <ul class="list-inline tab-list deskContent">
          <ng-container *ngFor="let om of ordersMainMenu">
            <li *ngIf="om.additional === 'N'" class="list-inline-item">
              <a (click)="populateTabData(om.tabClicked,om.orderStatus); tabChange()"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a>
            </li>
          </ng-container>
          <li class="list-inline-item">
            <a data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">+ more</a>
            <div class="dropdown-menu dropdown-menu2">
              <ng-container *ngFor="let om of ordersMainMenu">
                <a *ngIf="om.additional === 'Y'" class="dropdown-item"
                   (click)="populateTabData(om.tabClicked,om.orderStatus);switchPosition(om)"
                   [ngClass]="{'active':tabClicked === om.tabClicked}">{{om.displayName}}</a>
              </ng-container>
            </div>
          </li>
        </ul>
        <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
                [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;" required>
          <option *ngFor="let u of ordersMainMenu" [ngValue]="u.orderStatus" selected>{{u.displayName}}</option>
        </select>
      </div>
      <div class="col-md-4">
        <div class="text-right float-right">
          <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                  class="btn btn-outline-primary btn-sm dropdown-toggle ml-2 d-none-mobile"
                  *ngIf="(checkedList2?.length) && tabClicked !== 'all'">
            Actions
          </button>
          <div class="dropdown-menu dropdown-menu2  dropdown-menu-right"
               *ngIf="(checkedList2?.length) && tabClicked !== 'all'">
            <a *ngIf="tabClicked === 'submitted'" [ngClass]="{'disabled':disableAction('processing order')}"
               (click)="processingOrder(orders)" class="dropdown-item file btn shift-import">Process Order</a>
            <a *ngIf="tabClicked === 'InProcess'" [ngClass]="{'disabled':disableAction('print invoice')}"
               (click)="processingOrder(orders)" class="dropdown-item file btn shift-import">Process Order</a>
            <a *ngIf="tabClicked === 'InProcess'" [ngClass]="{'disabled':disableAction('created')}"
               (click)="generateShippingLabel(orders)" class="dropdown-item file btn shift-import">Generate Shipping
              Label</a>
            <a *ngIf="tabClicked === 'InProcess'" [ngClass]="{'disabled':disableAction('created')}"
               (click)="generateManifest(checkedOrderIdList)" class="dropdown-item file btn shift-import">Generate
              Manifest</a>
            <a (click)="cancelOrderPopUp(orders)"
               class="dropdown-item file btn shift-import">Cancel Order</a>
            <a (click)="holdOrderPopUp(orders)"
               class="dropdown-item file btn shift-import">Mark as On Hold</a>
            <a *ngIf="tabClicked === 'hold'" (click)="unHoldMultiOrders(orders)"
               class="dropdown-item file btn shift-import">Mark as Un Hold</a>
          </div>
          <button class="btn btn-orange ml-2" *ngIf="totalRecords != 0" (click)="syncOrders()">Sync Orders</button>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-2" [hidden]="totalRecords == 0">
    <div class="col">
      <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}">
        <table id="tables_id" class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" width="100%">
          <thead>
          <tr>
            <th></th>
            <th>Order #</th>
            <th>Channel Order #</th>
            <th style="width=150px; !important">Order Date</th>
            <th>Channel / Source</th>
            <th>Payment Method</th>
            <th
              *ngIf="tabClicked == 'created' || tabClicked == 'In_Process' || tabClicked == 'all' || tabClicked == 'readyToShip' || tabClicked == 'shipped'">
              Customer Name
            </th>
            <th
              *ngIf="tabClicked == 'created' || tabClicked == 'In_Process' || tabClicked == 'all' || tabClicked == 'readyToShip' || tabClicked == 'shipped'">
              Customer City
            </th>
            <th *ngIf="tabClicked == 'all' || tabClicked == 'readyToShip' || tabClicked == 'shipped'">Carrier Name</th>
            <th *ngIf="tabClicked == 'all' || tabClicked == 'readyToShip' || tabClicked == 'shipped'">AWB #</th>
            <th>Status</th>
            <th></th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let o of orders">
            <td>
              <div class="form-checkbox" *ngIf="tabClicked == 'submitted' || tabClicked == 'hold' || tabClicked == 'readyToShip' || tabClicked == 'InProcess' || tabClicked == 'Delivered'">
                <input type="checkbox" id="{{o.orderHeaderId}}" [(ngModel)]="o.isSelected" name="list_name"
                       (change)="selectShip(o)">
                <label for="{{o.orderHeaderId}}"></label></div>
            </td>
            <td><a routerLink="/admin/viewOrders/{{o.orderHeaderId}}">{{o.orderNumber}}</a></td>
            <td>{{o.channelOrderNumber || '--'}}</td>
            <td style="width=150px; !important">{{(o.createdDate) | date: 'dd-MMM-yyyy'}}</td>
            <td>{{o.sourceType | replaceStatus}}</td>
            <td>{{o.paymentMethod | replaceStatus}}</td>
            <td
              *ngIf="tabClicked == 'created' || tabClicked == 'In_Process' || tabClicked == 'all' || tabClicked == 'readyToShip' || tabClicked == 'shipped'">{{o.receiverName | replaceStatus}}</td>
            <td
              *ngIf="tabClicked == 'created' || tabClicked == 'In_Process' || tabClicked == 'all' || tabClicked == 'readyToShip' || tabClicked == 'shipped'">{{o.receiverCity}}</td>
            <td
              *ngIf="tabClicked == 'all' || tabClicked == 'readyToShip' || tabClicked == 'shipped'">{{(o.shippingOption == 'SD' ? 'Shift' :
              (o.shippingOption == 'DL' ? 'Delhivery' :
                (o.shippingOption == 'GT' ? 'Gati' :
                  (o.shippingOption == 'DZ' ? 'Dotzot' :
                    (o.shippingOption == 'RD' ? 'Rapid Delivery' :
                      (o.shippingOption == 'SF' ? 'Shadow Fax' :
                        (o.shippingOption == 'BD' ? 'Blue Dart' :
                          (o.shippingOption == 'PR' ? 'Pickrr' :
                            (o.shippingOption == 'SY' ? 'Ship Yaari' :
                              (o.shippingOption == 'DE' ? 'Delhivery' :
                                (o.shippingOption == 'SG' ? 'Shippigo' :
                                  (o.shippingOption == 'VS' ? 'Vamaship' :
                                    (o.shippingOption == 'DN' ? 'Dunzo' :
                                      (o.shippingOption == 'WF' ? 'Borzo' :
                                        (o.shippingOption == 'FE' ? 'FedEx' : o.shippingOption)))))))))))))))}}</td>
            <td
              *ngIf="tabClicked == 'all' || tabClicked == 'readyToShip' || tabClicked == 'shipped'">{{o.trackingNumber}}</td>
            <td>
              <div class="text-truncate" title="{{o.orderStatus | replaceStatus}}"
                   style="width:100px;">{{o.orderStatus | replaceStatus}}
              </div>
            </td>
            <td>
              <div
                *ngIf="o.trackingNumber !== null && o.orderStatus !== 'CANCELLED'">
                <a routerLink="/trackOutboundOrder/{{o.orderHeaderId}}/{{o.accountOwnerId}}" target="_blank">
                  <img src="assets/images/dsBuffer.png" width="30" height="30" alt="trackImage">
                </a>
              </div>
            </td>
          </tr>
          </tbody>
          <tfoot *ngIf="totalCount == 0">
          <td colspan="11"><span class="align-items-center">No Records Found</span></td>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</section>

<div [ngStyle]="{'display': cancelActivities =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': cancelActivities == 'Y'}" class="modal" id="popUpAssign" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-45 modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleDriverModalPreviewLabel">Cancel Order</h5>
        <button type="button" class="close" (click)="closePopUp()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <div class="row">
                <div class="col">
                  <label class="control-label" for="cancelReason">Cancel Reason</label>
                  <select id="cancelReason" class="form-control" [(ngModel)]="reason"
                          [ngModelOptions]="{standalone: true}" required>
                    <option *ngFor="let c of cancelReasons" [ngValue]="c.config">{{c.config}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-cancel ml-1" (click)="closePopUp()">Cancel</button>
              <button type="submit" class="btn btn-orange ml-1" (click)="cancelMultiOrders(orders)">Ok</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div [ngStyle]="{'display': holdActivities =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': holdActivities == 'Y'}" class="modal" id="popUpHold" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-45 modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleHoldLabel">Orders to put on Hold</h5>
        <button type="button" class="close" (click)="closePopUpHold()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <div class="d-none d-sm-block">
                <div calss="row">
                  <div calss="col">
                    <table class="table">
                      <thead>
                      <tr>
                        <th>Channel Order #</th>
                        <th>Order Date</th>
                        <th>Contact</th>
                        <th>Warehouse</th>
                        <th>Action</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let l of checkedListView;let i=index">
                        <td>{{l.sourceOrderId}}</td>
                        <td>{{l.orderedDate}}</td>
                        <td style="text-transform:capitalize;">{{l.contactCompanyName}}-{{l.contactName}}</td>
                        <td>{{l.warehouseName}}</td>
                        <td>
                          <a (click)="splice(i,l.orderHeaderId)">
                            <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" height="21" viewBox="0 0 18.877 24.27">
                              <defs>
                                <style>.a {
                                  fill: #848484;
                                }

                                </style>
                              </defs>
                              <path class="a"
                                    d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                                    transform="translate(-7.5 -4.5)"/>
                            </svg>
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <label class="control-label" for="hold">Hold Reason</label>
                  <div class="form-group mt-2">
                    <textarea type="text" id="hold" [(ngModel)]="activityDetails" class="form-control"
                              [ngModelOptions]="{standalone: true}" required></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-cancel ml-1" (click)="closePopUpHold()">Cancel</button>
              <button type="submit" class="btn btn-orange ml-1" (click)="holdMultiOrders(orders)">Ok</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div [ngStyle]="{'display': pdfGenerate =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': pdfGenerate == 'Y'}" class="modal" id="popupShippingLabel" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleShippingLabel">Choose Print Option</h5>
        <button type="button" id="enterQuantity" class="close" (click)="close()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>

          <div class="row">
            <div class="col-8">
              <div class="form-group required">
                <!--                <label class="control-label" for="printSize2">Print Size Option</label>-->
                <select class="form-control" id="printSize2" [(ngModel)]="size" [ngModelOptions]="{standalone: true}"
                        [ngClass]="{'is-invalid':sizeError}" required>
                  <option value="Custom">Label Printer (101mm X 150mm)</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!sizeError">{{sizeError}}</div>
              </div>
            </div>


            <div class="col-4 text-right">
              <button type="submit" class="btn btn-orange ml-1" (click)="printShipment()">Submit</button>
            </div>

          </div>


        </form>
      </div>
    </div>
  </div>
</div>



